// The parts of @edx/frontend-platform used by the shared ThervuMitra UI
// (thervumitra/: language switcher, newsletter form, strings, links), on top of
// frontend-base. webpack.config.build.js aliases @edx/frontend-platform,
// /i18n and /auth to this file, so those components build unchanged here.
import {
  getAuthenticatedHttpClient, getAuthenticatedUser, getLocale, getSiteConfig,
} from '@openedx/frontend-base';

// The classic MFE_CONFIG keys: commonAppConfig (MFE_CONFIG from lms.yml) plus
// the site's own URLs under their classic names.
export function getConfig(): Record<string, any> {
  const site = getSiteConfig() as any;
  const common = site.commonAppConfig || {};
  const base = (site.baseUrl || '').replace(/\/$/, '');
  return {
    ...common,
    SITE_NAME: site.siteName,
    BASE_URL: site.baseUrl,
    LMS_BASE_URL: site.lmsBaseUrl,
    STUDIO_BASE_URL: site.cmsBaseUrl,
    LOGO_URL: site.headerLogoImageUrl,
    LANGUAGE_PREFERENCE_COOKIE_NAME: site.languagePreferenceCookieName,
    LEARNER_HOME_MICROFRONTEND_URL: common.LEARNER_HOME_MICROFRONTEND_URL || `${base}/learner-dashboard/`,
  };
}

export { getAuthenticatedHttpClient, getAuthenticatedUser, getLocale };
